import Swiper from 'swiper';
import { Navigation, Controller, EffectFade } from 'swiper/modules';

export default function initCarousel() {
    const carousels = document.querySelectorAll('.carousel');

    carousels.forEach((container) => {
        const mainEl = container.querySelector('.swiper:not(.captions)');
        const captionsEl = container.querySelector('.captions.swiper');

        const swiperCaptions = new Swiper(captionsEl, {
            modules: [Controller, EffectFade],
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            allowTouchMove: false,
        });

        const swiperMain = new Swiper(mainEl, {
            modules: [Navigation, Controller],
            slidesPerView: 1,
            navigation: {
                nextEl: container.querySelector('.btn--next'),
                prevEl: container.querySelector('.btn--prev'),
            },
            grabCursor: true,
        });

        swiperMain.controller.control = swiperCaptions;
        swiperCaptions.controller.control = swiperMain;
    });
}
